import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { CoreUserInfoService } from 'common/data';

class CoreUserInfoStore extends BaseStore {
	constructor(rootStore) {
		super(new CoreUserInfoService(rootStore.app.baasic.apiClient));
	}

	@action async findCoreUserInfo(filter) {
		const response = await this.service.find(filter);
		this.response = response.data;
	}

	@action async updateCoreUserInfo(resource, sourceOfChange) {
		const response = await this.service.update(resource, sourceOfChange);
		this.response = response.data;
	}
}

export default CoreUserInfoStore;
